import { AlertField } from '@/v5/components/molecules/AlertField/AlertField';

function AuthAlerts({
    action,
    loginActionMessage,
    loginError,
    message,
    status,
}) {
    return (
        <>
            {!loginError?.isError && message && (
                <AlertField
                    status="warning"
                    className="text-black"
                    sx={{ overflow: 'visible' }}
                    message={message}
                />
            )}
            {action && (
                <AlertField
                    status="success"
                    className="text-black"
                    sx={{ overflow: 'visible' }}
                    message={loginActionMessage}
                />
            )}
            {status && (
                <AlertField
                    status="error"
                    className="text-black"
                    message={status}
                />
            )}
        </>
    );
}

export { AuthAlerts };
